import { __ } from '@wordpress/i18n';
import { 
  PanelBody, 
  SelectControl,
  __experimentalBoxControl as BoxControl, 
} from "@wordpress/components";

import { useEffect, useState } from '@wordpress/element';

import borderStyles from '../assets/borderStyles';
import defaultColors from '../assets/defaultColors';

import ColorControl from './color-control';

function BorderControl(props) {
  const borderWidthString = props.value?.borderWidth?.split(' ');

  const [borderWidth, setBorderWidth] = useState({
    top: borderWidthString ? borderWidthString[0] : '0px',
    right: borderWidthString ? borderWidthString[1] : '0px',
    bottom: borderWidthString ? borderWidthString[2] : '0px',
    left: borderWidthString ? borderWidthString[3] : '0px'
  });
  const [borderStyle, setBorderStyle] = useState(props.value?.borderStyle ? props.value.borderStyle : 'solid');
  const [borderColor, setBorderColor] = useState(props.value?.borderColor ? props.value.borderColor : '#000');

  useEffect(() => {
    props.onChange({
      borderWidth: `${borderWidth.top} ${borderWidth.right} ${borderWidth.bottom} ${borderWidth.left}`,
      borderStyle,
      borderColor
    });
  }, [
    borderColor,
    borderStyle,
    borderWidth
  ]);

  return (
    <PanelBody title={__('Border')} initialOpen={false}>
      <BoxControl
        value={borderWidth}
        onChange={setBorderWidth}
      />
      <SelectControl 
        options={borderStyles}
        value={borderStyle}
        onChange={setBorderStyle}
      />
      <ColorControl 
        label={__('Border color')}
        value={borderColor}
        onChange={setBorderColor}
        colors={defaultColors}
      />
    </PanelBody>
  );
}

export default BorderControl;